import React from "react";
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio} from "@mui/material";
import './ToggleRadioGroup.css';

interface ToggleRadioGroupProps {
    label: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    options?: { label: string; value: string }[];
    disabled?: boolean;
}

const ToggleRadioGroup: React.FC<ToggleRadioGroupProps> = ({
    label,
    value,
    onChange,
    options = [
        { label: "Enable", value: "enabled" },
        { label: "Disable", value: "disabled" },
    ],
    disabled = false,
}) => {
    return (
        <FormControl component="fieldset" className="formLabelContainer">
            <FormLabel component="legend" className="formLabel">
                {label}
            </FormLabel>
            <RadioGroup row value={value} onChange={onChange}>
                {options?.map((opt) => (
                    <FormControlLabel
                        key={opt.value}
                        value={opt.value}
                        control={<Radio size="small" />}
                        label={opt.label}
                        disabled={disabled}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
};

export default ToggleRadioGroup;